import { createAction } from 'redux-act'

const loginStart = createAction('Login - Start')
const loginSuccess = createAction('Login - Success')
const loginErrors = createAction('Login - Errors')
export const clearLoginErrors = createAction('Login - Clear errors')

const proceedToCheckoutStart = createAction('Login checkout proceed - Start')
const proceedToCheckoutSuccess = createAction('Login checkout proceed - Success')
const proceedToCheckoutFail = createAction('Login checkout proceed - Fail')
const proceedToCheckoutReset = createAction('Login checkout proceed - Reset')

const fetchLoyaltyBenefitsListStart = createAction('Fetch loyalty benefits list - Start')
const fetchLoyaltyBenefitsListSuccess = createAction('Fetch loyalty benefits list - Success')
const fetchLoyaltyBenefitsListFail = createAction('Fetch loyalty benefits list - Fail')

export default {
  loginStart,
  loginSuccess,
  loginErrors,
  proceedToCheckoutStart,
  proceedToCheckoutSuccess,
  proceedToCheckoutFail,
  proceedToCheckoutReset,
  fetchLoyaltyBenefitsListStart,
  fetchLoyaltyBenefitsListSuccess,
  fetchLoyaltyBenefitsListFail,
}
